import axios from "axios";
import { authorizationHeaders } from "../../../../common/apis/auth";
import { Urls } from "../../../../common/apis/urls";
import { CityModel } from "../../models/city.model";
import { DataViewResult, toCityModel } from "./contracts/dataview.result";

export async function fetchCity(id: string): Promise<CityModel> {
    const { data } = await axios.get<DataViewResult>(Urls.getCityDataview(id), authorizationHeaders());
    return toCityModel(data);
}